import { r as registerInstance, c as createEvent, h, F as Fragment, H as Host, g as getElement } from './index-506c059e.js';
import { c as classNames } from './index-f9dffc47.js';

// import { Color } from '../types/color'
const BUTTON_VARIANTS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    COMPLEMENTARY: 'complementary',
    DESTRUCTIVE: 'destructive',
    INFORMATION_PRIMARY: 'information-primary',
    INFORMATION_SECONDARY: 'information-secondary',
    SUCCESS_PRIMARY: 'success-primary',
    SUCCESS_SECONDARY: 'success-secondary',
    WARNING_PRIMARY: 'warning-primary',
    WARNING_SECONDARY: 'warning-secondary',
    ERROR_PRIMARY: 'error-primary',
    ERROR_SECONDARY: 'error-secondary',
    DOWNLOAD_FILE: 'download-file',
    LEGAL_DISCLAIMER_PRIMARY: "legal-disclaimer-primary",
    LEGAL_DISCLAIMER_SECONDARY: "legal-disclaimer-secondary",
};
const BUTTON_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
};
const BUTTON_HEIGHTS = {
    small: '32px',
    medium: '40px',
    large: '48px',
    xlarge: '56px',
};
const BUTTON_STATES = {
    DEFAULT: 'normal',
    HOVER: 'hover',
    FOCUS: 'focus',
    ACTIVE: 'active',
    LOADING: 'loading',
    DISABLED: 'disabled',
};
const BUTTON_LABEL_STYLES = {
    DEFAULT: {
        variant: 'prelo',
        //color: 'bp-grayScale500' as Color,
        weight: '600',
        size: '14px',
        'line-height': '24px',
        spacing: 0,
        decoration: 'none',
        category: 'text',
    },
    SMALL: {
        variant: 'prelo',
        //color: 'bp-grayScale500' as Color,
        weight: '600',
        size: '12px',
        'line-height': '16px',
        spacing: 0,
        decoration: 'none',
        category: 'text',
    },
};
const BUTTON_VARIANTS_ARR = Object.values(BUTTON_VARIANTS);
const BUTTON_SIZES_ARR = Object.values(BUTTON_SIZES);
Object.values(BUTTON_HEIGHTS);
const BUTTON_STATES_ARR = Object.values(BUTTON_STATES);
Object.values(BUTTON_LABEL_STYLES);
const BUTTON = {
    VARIANTS: BUTTON_VARIANTS,
    SIZES: BUTTON_SIZES,
    HEIGHTS: BUTTON_HEIGHTS,
    STATES: BUTTON_STATES,
    LABEL_STYLES: BUTTON_LABEL_STYLES,
    TYPES_ARR: BUTTON_VARIANTS_ARR,
    SIZES_ARR: BUTTON_SIZES_ARR,
    STATES_ARR: BUTTON_STATES_ARR,
    LABEL_STYLES_ARR: BUTTON_LABEL_STYLES,
};

function parseSize(size) {
    const values = size.split(/\s+/);
    const parsedSizes = [];
    for (const value of values) {
        const regex = /^([+-]?\d{1,7}(?:\.\d{1,7})?)([a-z%]*)$/i;
        const result = regex.exec(value);
        if (!result) {
            return null;
        }
        const numericValue = parseFloat(result[1]);
        const unit = result[2];
        const absoluteUnits = ['px', 'pt', 'pc', 'cm', 'mm', 'in', 'Q'];
        const relativeUnits = [
            'em',
            'ex',
            'ch',
            'rem',
            'lh',
            'rlh',
            'vw',
            'vh',
            'vmin',
            'vmax',
            'vb',
            'vi',
            'svw',
            'svh',
            'lvw',
            'lvh',
            'dvw',
            'dvh',
            '%',
        ];
        if (!absoluteUnits.includes(unit) && !relativeUnits.includes(unit)) {
            return null;
        }
        parsedSizes.push({
            value: numericValue,
            unit: unit,
            type: absoluteUnits.includes(unit) ? 'absolute' : 'relative',
        });
    }
    return parsedSizes;
}

const ICON_SIZES = {
    SMALL: '16px',
    MEDIUM: '24px',
};

const buttonCss = ":host{display:-ms-inline-flexbox;display:inline-flex;vertical-align:top}:host,:host *{-webkit-box-sizing:border-box;box-sizing:border-box}.button{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border-radius:4px;padding:8px;cursor:pointer;-webkit-transition:background-color 0.1s ease-in-out;transition:background-color 0.1s ease-in-out;border:1px solid transparent}.button__label{pointer-events:none;padding-left:8px;padding-right:8px}.button .spinner{width:24px;height:24px;padding:1px}.button .spinner__wrapper{position:relative;width:100%;height:100%}.button .spinner__background,.button .spinner__quarter{position:absolute;border:4px solid;border-radius:50%;width:100%;height:100%}.button .spinner__background{opacity:0.1}.button .spinner__quarter{-webkit-clip-path:polygon(50% 0%, 100% 0%, 100% 50%, 50% 50%);clip-path:polygon(50% 0%, 100% 0%, 100% 50%, 50% 50%);-webkit-animation:spin 0.66s infinite linear;animation:spin 0.66s infinite linear}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.button[disabled],.button.loading{cursor:not-allowed}.button.primary{background-color:var(--bp-primary-yellow500);color:var(--bp-primary-blue500)}.button.primary:hover{background-color:var(--bp-primary-yellow700)}.button.primary:focus{background-color:var(--bp-primary-yellow500);outline:2px solid var(--bp-alert-information500)}.button.primary:active{background-color:var(--bp-primary-yellow900)}.button.primary.loading{background-color:var(--bp-primary-yellow500);outline:0px}.button.primary[disabled]{background-color:var(--bp-primary-yellow200);color:var(--bp-primary-blue200)}.button.secondary{background-color:var(--bp-secondary-darkGrayishBlue200);border:1px solid var(--bp-secondary-darkGrayishBlue300);color:var(--bp-primary-blue500)}.button.secondary:hover{background-color:var(--bp-secondary-darkGrayishBlue500);border:1px solid var(--bp-secondary-darkGrayishBlue600)}.button.secondary:focus{background-color:var(--bp-secondary-darkGrayishBlue200);border:1px solid var(--bp-secondary-darkGrayishBlue300);outline:2px solid var(--bp-alert-information500)}.button.secondary:active{background-color:var(--bp-secondary-darkGrayishBlue700);border:1px solid var(--bp-secondary-darkGrayishBlue800)}.button.secondary.loading{background-color:var(--bp-secondary-darkGrayishBlue200);border:1px solid var(--bp-secondary-darkGrayishBlue300);outline:0px}.button.secondary[disabled]{background-color:var(--bp-secondary-darkGrayishBlue100);border:1px solid transparent;color:var(--bp-primary-blue200)}.button.tertiary{background-color:var(--bp-grayScaleWhite);border:1px solid var(--bp-primary-blue500);color:var(--bp-primary-blue500)}.button.tertiary:hover{background-color:var(--bp-secondary-darkGrayishBlue200);border:1px solid var(--bp-primary-blue500)}.button.tertiary:focus{background-color:var(--bp-grayScaleWhite);border:1px solid var(--bp-primary-blue500);outline:2px solid var(--bp-alert-information500)}.button.tertiary:active{background-color:var(--bp-secondary-darkGrayishBlue400);border:1px solid var(--bp-primary-blue500)}.button.tertiary.loading{background-color:var(--bp-grayScaleWhite);border:1px solid var(--bp-primary-blue500);outline:0px}.button.tertiary[disabled]{background-color:var(--bp-grayScaleWhite);border:1px solid var(--bp-primary-blue200);color:var(--bp-primary-blue200)}.button.complementary{background-color:var(--bp-primary-blue500);color:white}.button.complementary:hover{background-color:var(--bp-primary-blue600)}.button.complementary:focus{background-color:var(--bp-primary-blue500);outline:2px solid var(--bp-alert-information500)}.button.complementary:active{background-color:var(--bp-primary-blue700)}.button.complementary.loading{background-color:var(--bp-primary-blue500);outline:0px}.button.complementary.loading .spinner__background{opacity:0.2}.button.complementary[disabled]{background-color:var(--bp-primary-blue200);color:var(--bp-primary-blue100)}.button.destructive{background-color:var(--bp-alert-error500);color:white}.button.destructive:hover{background-color:var(--bp-alert-error700)}.button.destructive:focus{background-color:var(--bp-alert-error500);outline:2px solid var(--bp-alert-information500)}.button.destructive:active{background-color:var(--bp-alert-error900)}.button.destructive.loading{background-color:var(--bp-alert-error500);outline:0px}.button.destructive.loading .spinner__background{opacity:0.2}.button.destructive[disabled]{background-color:var(--bp-alert-error200);color:var(--bp-alert-error100)}.button.information-primary{background-color:var(--bp-alert-information500);color:var(--bp-grayScaleWhite)}.button.information-primary:hover{background-color:var(--bp-alert-information700)}.button.information-primary:focus{background-color:var(--bp-alert-information500);outline:2px solid var(--bp-alert-information500)}.button.information-primary:active{background-color:var(--bp-alert-information800)}.button.information-secondary{background-color:var(--bp-alert-information100);border:1px solid var(--bp-alert-information200);color:var(--bp-grayScale500)}.button.information-secondary:hover{background-color:var(--bp-alert-information200);border:1px solid var(--bp-alert-information300)}.button.information-secondary:focus{background-color:var(--bp-alert-information100);border:1px solid var(--bp-alert-information200);outline:2px solid var(--bp-alert-information500)}.button.information-secondary:active{background-color:var(--bp-alert-information300);border:1px solid var(--bp-alert-information400)}.button.success-primary{background-color:var(--bp-alert-success500);color:var(--bp-grayScaleWhite)}.button.success-primary:hover{background-color:var(--bp-alert-success700)}.button.success-primary:focus{background-color:var(--bp-alert-success500);outline:2px solid var(--bp-alert-information500)}.button.success-primary:active{background-color:var(--bp-alert-success800)}.button.success-secondary{background-color:var(--bp-alert-success100);border:1px solid var(--bp-alert-success200);color:var(--bp-grayScale500)}.button.success-secondary:hover{background-color:var(--bp-alert-success200);border:1px solid var(--bp-alert-success300)}.button.success-secondary:focus{background-color:var(--bp-alert-success100);border:1px solid var(--bp-alert-success200);outline:2px solid var(--bp-alert-information500)}.button.success-secondary:active{background-color:var(--bp-alert-success300);border:1px solid var(--bp-alert-success400)}.button.warning-primary{background-color:var(--bp-alert-warning500);color:var(--bp-grayScaleWhite)}.button.warning-primary:hover{background-color:var(--bp-alert-warning700)}.button.warning-primary:focus{background-color:var(--bp-alert-warning500);outline:2px solid var(--bp-alert-information500)}.button.warning-primary:active{background-color:var(--bp-alert-warning800)}.button.warning-secondary{background-color:var(--bp-alert-warning100);border:1px solid var(--bp-alert-warning200);color:var(--bp-grayScale500)}.button.warning-secondary:hover{background-color:var(--bp-alert-warning200);border:1px solid var(--bp-alert-warning300)}.button.warning-secondary:focus{background-color:var(--bp-alert-warning100);border:1px solid var(--bp-alert-warning200);outline:2px solid var(--bp-alert-information500)}.button.warning-secondary:active{background-color:var(--bp-alert-warning300);border:1px solid var(--bp-alert-warning400)}.button.error-primary{background-color:var(--bp-alert-error500);color:var(--bp-grayScaleWhite)}.button.error-primary:hover{background-color:var(--bp-alert-error700)}.button.error-primary:focus{background-color:var(--bp-alert-error500);outline:2px solid var(--bp-alert-information500)}.button.error-primary:active{background-color:var(--bp-alert-error800)}.button.error-secondary{background-color:var(--bp-alert-error100);border:1px solid var(--bp-alert-error200);color:var(--bp-grayScale500)}.button.error-secondary:hover{background-color:var(--bp-alert-error200);border:1px solid var(--bp-alert-error300)}.button.error-secondary:focus{background-color:var(--bp-alert-error100);border:1px solid var(--bp-alert-error200);outline:2px solid var(--bp-alert-information500)}.button.error-secondary:active{background-color:var(--bp-alert-error300);border:1px solid var(--bp-alert-error400)}.button.legal-disclaimer-secondary{background-color:var(--bp-grayScale50);border:1px solid var(--bp-grayScale200);color:var(--bp-grayScale500)}.button.legal-disclaimer-secondary:hover{background-color:var(--bp-grayScale100);border:1px solid var(--bp-grayScale300)}.button.legal-disclaimer-secondary:focus{background-color:var(--bp-primary-blue50);border:1px solid var(--bp-grayScale300);outline:2px solid var(--bp-alert-information500)}.button.legal-disclaimer-secondary:active{background-color:var(--bp-grayScale100);border:1px solid var(--bp-grayScale300)}.button.legal-disclaimer-primary{background-color:var(--bp-grayScale500, #2c2c30);color:var(--bp-grayScaleWhite)}.button.legal-disclaimer-primary:hover{background-color:var(--bp-grayScale500)}.button.legal-disclaimer-primary:focus{background-color:var(--bp-grayScale500);outline:2px solid var(--bp-alert-information500)}.button.legal-disclaimer-primary:active{background-color:var(--bp-grayScale500)}.button.download-file{background-color:var(--bp-secondary-darkGrayishBlue50);border:1px solid var(--bp-secondary-darkGrayishBlue300);color:var(--bp-primary-blue500)}.button.download-file:hover{background-color:var(--bp-alert-information50);border:1px solid var(--bp-alert-information500)}.button.download-file:focus{background-color:var(--bp-secondary-darkGrayishBlue50);border:1px solid var(--bp-secondary-darkGrayishBlue300);outline:2px solid var(--bp-alert-information500)}.button.download-file:active{background-color:var(--bp-secondary-darkGrayishBlue100);border:1px solid var(--bp-secondary-darkGrayishBlue400);outline:0 solid var(--bp-alert-information500)}.button.download-file.loading{background-color:var(--bp-secondary-darkGrayishBlue200);border:1px solid var(--bp-secondary-darkGrayishBlue300);outline:0px}.button.download-file[disabled]{background-color:var(--bp-secondary-darkGrayishBlue100);border:1px solid transparent;color:var(--bp-primary-blue200)}.button.xlarge{height:56px;padding:16px}.button.large{height:48px;padding:12px 16px}.button.medium{height:40px;padding:8px 16px}.button.small{height:32px;padding:8px}.button.small .spinner{width:16px;height:16px;padding:0.33px}.button.small .spinner__background,.button.small .spinner__quarter{border:2px solid}.button--no-border{border:none !important}";
const PichinchaButtonStyle0 = buttonCss;

const Button = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clickEvent = createEvent(this, "clickEvent", 7);
        this.isIconSlotValid = true;
        this.isTextSlotValid = true;
        this.isDropdownIconSlotValid = true;
        this.getSlot = (slotName, children) => {
            const elements = Array.from(children).filter((child) => child.slot === slotName);
            const isSlotValid = elements.length === 1;
            const htmlOutput = isSlotValid ? h("slot", { name: slotName }) : null;
            return {
                html: htmlOutput,
                isValid: isSlotValid,
            };
        };
        this.validateSlots = (children) => {
            const textElements = this.getSlot('text', children);
            const iconElements = this.getSlot('icon', children);
            const dropdownIconElements = this.getSlot('dropdown', children);
            return {
                isTextSlotValid: textElements.isValid,
                isIconSlotValid: iconElements.isValid,
                isDropdownIconSlotValid: dropdownIconElements.isValid,
            };
        };
        this.handleClick = (event) => {
            this.clickEvent.emit({
                id: this.buttonId,
                label: this.label,
                iconName: this.iconName,
                'aria-label': this.calculateButtonAriaLabel(),
                event: event,
            });
            if (this.href) {
                window.location.href = this.href;
            }
        };
        this.label = '';
        this.variant = BUTTON.VARIANTS.PRIMARY;
        this.size = undefined;
        this.iconName = '';
        this.dropdownIcon = false;
        this.disabled = false;
        this.loading = false;
        this.rightIconName = undefined;
        this.hideBorder = undefined;
        this.href = undefined;
        this.buttonId = undefined;
        this.buttonTabIndex = undefined;
        this.buttonAriaLabel = '';
        this.customWidth = '';
        this.customHeight = '';
        this.customPadding = '';
        this.customLabelPadding = '';
        this.customBorderRadius = '';
    }
    componentWillLoad() {
        const { isTextSlotValid, isIconSlotValid, isDropdownIconSlotValid } = this.validateSlots(this.host.children);
        this.isTextSlotValid = isTextSlotValid;
        this.isIconSlotValid = isIconSlotValid;
        this.isDropdownIconSlotValid = isDropdownIconSlotValid;
    }
    calculateButtonAriaLabel() {
        if (this.buttonAriaLabel !== '') {
            return this.buttonAriaLabel;
        }
        if (this.label !== '' && !this.isTextSlotValid) {
            return this.label;
        }
        if (this.iconName !== '' && !this.isIconSlotValid) {
            return `Botón con icono '${this.iconName}'`;
        }
        return 'No hay descripción de la acción';
    }
    updateCustomStyles(customWidth, customHeight, customPadding, customLabelPadding, customBorderRadius) {
        const parsedSizes = {
            width: parseSize(customWidth),
            height: parseSize(customHeight),
            padding: parseSize(customPadding),
            labelPadding: parseSize(customLabelPadding),
            borderRadius: parseSize(customBorderRadius),
        };
        const buttonCustomStyles = {};
        const hostCustomStyles = {};
        const labelCustomStyles = {};
        if (parsedSizes.width) {
            buttonCustomStyles.width = customWidth;
            if (parsedSizes.width[0].type === 'absolute') {
                hostCustomStyles.width = customWidth;
            }
        }
        if (parsedSizes.height) {
            buttonCustomStyles.height = customHeight;
            if (parsedSizes.height[0].type === 'absolute') {
                hostCustomStyles.height = customHeight;
            }
        }
        if (parsedSizes.padding) {
            buttonCustomStyles.padding = customPadding;
        }
        if (parsedSizes.labelPadding) {
            labelCustomStyles.padding = customLabelPadding;
        }
        if (parsedSizes.borderRadius) {
            buttonCustomStyles.borderRadius = customBorderRadius;
        }
        return {
            buttonCustomStyles,
            hostCustomStyles,
            labelCustomStyles,
        };
    }
    applyCustomSizeRules(customWidth, customHeight, size, buttonCustomStyles, hostCustomStyles) {
        if (customWidth === '') {
            buttonCustomStyles.width = BUTTON.HEIGHTS[size];
            hostCustomStyles.width = BUTTON.HEIGHTS[size];
        }
        if (customHeight === '') {
            buttonCustomStyles.height = BUTTON.HEIGHTS[size];
            hostCustomStyles.height = BUTTON.HEIGHTS[size];
        }
    }
    render() {
        const iconSlot = this.getSlot('icon', this.host.children);
        const textSlot = this.getSlot('text', this.host.children);
        const dropdownSlot = this.getSlot('dropdown', this.host.children);
        const { buttonCustomStyles, hostCustomStyles, labelCustomStyles } = this.updateCustomStyles(this.customWidth, this.customHeight, this.customPadding, this.customLabelPadding, this.customBorderRadius);
        const classes = classNames('button', this.variant, this.size, {
            loading: this.loading,
            'button--no-border': this.hideBorder,
        });
        const onlyLeftIcon = (this.iconName !== '' || iconSlot.isValid) &&
            this.label === '' &&
            !textSlot.isValid;
        const iconAttributes = this.size === BUTTON.SIZES.SMALL
            ? { size: ICON_SIZES.SMALL }
            : { size: ICON_SIZES.MEDIUM };
        if (onlyLeftIcon && !iconSlot.isValid) {
            this.applyCustomSizeRules(this.customWidth, this.customHeight, this.size, buttonCustomStyles, hostCustomStyles);
        }
        const typographyAttributes = this.size === BUTTON.SIZES.SMALL
            ? BUTTON.LABEL_STYLES.SMALL
            : BUTTON.LABEL_STYLES.DEFAULT;
        const buttonAttributes = {
            id: this.buttonId,
            tabindex: this.buttonTabIndex,
            class: classes,
            disabled: !this.loading && this.disabled,
            style: buttonCustomStyles,
            onClick: this.handleClick,
            'aria-label': this.calculateButtonAriaLabel(),
            'aria-disabled': this.disabled,
            role: this.href ? 'link' : 'button',
        };
        return (h(Host, { key: 'caa49d07418827ca6ad414e2c69cbd4e2a8b69c7', style: Object.assign({}, hostCustomStyles) }, h("button", Object.assign({ key: '757bfeaacedb29cdde3aeaf76a627cf2c903f91d' }, buttonAttributes), this.loading === true ? (h("div", { class: "spinner" }, h("div", { class: "spinner__wrapper" }, h("div", { class: "spinner__background" }), h("div", { class: "spinner__quarter" })))) : (h(Fragment, null, !iconSlot.isValid && this.iconName !== '' && (h("pichincha-icon", Object.assign({}, iconAttributes), this.iconName)), iconSlot.html, (textSlot.isValid || this.label !== '') && (h("div", { class: "button__label", style: Object.assign({}, labelCustomStyles) }, !textSlot.isValid && this.label !== '' && (h("pichincha-typography", Object.assign({}, typographyAttributes), this.label)), textSlot.html)), (this.label !== '' || textSlot.isValid) &&
            !dropdownSlot.isValid &&
            this.dropdownIcon === true && (h("pichincha-icon", Object.assign({}, iconAttributes), "arrow_drop_down")), this.rightIconName && (h("pichincha-icon", Object.assign({}, iconAttributes), this.rightIconName)), (this.label !== '' || textSlot.isValid) && dropdownSlot.html)))));
    }
    get host() { return getElement(this); }
};
Button.style = PichinchaButtonStyle0;

export { Button as pichincha_button };
